import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({ selector: '[appHasDisplayIcons]' })
export class HasDisplayIconsDirective implements OnInit {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);

  private bucketType: string;
  private icon: string;

  private allowedIcons = {
    "StudyDataCollection":["Upload","Create Folder","Transfer","Version History","Folder Templates"],
    "FacilityDataCollection":["Upload","Create Folder","Transfer","Version History","Folder Templates"],
    "PreArchive":["Create Folder","Transfer","Version History"],
    "FacilityArchive":["Version History"]
  };

  @Input() set appHasDisplayIcons(bucketType: any) {
    this.bucketType = bucketType;
  }

  @Input() set appHasDisplayIconsType(icon: any) {
    this.icon = icon;
  }

  ngOnInit(): void {
    this.assignIcons();
  }

  assignIcons() {
    const allowedList = (this.allowedIcons as any)[this.bucketType];
    if (allowedList && allowedList.includes(this.icon)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
